/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
// import { FindOneOptions, FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/proposal-item-logs';

export const ProposalItemLogApi = {
  find: async (option: any) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
